import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn, Router } from '@angular/router';
import { ClientService } from '../services/client.service';
import { BadgesService } from '../modules/badges/badges.service';
import { KarmaPointsService } from '../modules/karma-points/services/karma-points.service';
import { checkRouteAuthorization, RouteAccessConfig } from '../utils/route-auth.utils';

export const smsAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const clientService = inject(ClientService);
  const badgesService = inject(BadgesService);
  const karmaPointsService = inject(KarmaPointsService);
  const user = clientService.user();
  if (!user?.role?.name || user?.role?.name === 'Global Admin') {
    router.navigateByUrl('globalAdmin/clients');
    return false;
  }

  const routeCheckAccessMap: Record<string, RouteAccessConfig> = {
    'overview': 'myLearningsOverview',
    'overview/viewAll': 'myLearningsOverview',
    'specializations': 'myLearningsSpecializations',
    'specializations/viewAll': 'myLearningsBySpecialization',
    'individualLearnings': 'myLearningsIndividualLearning',
    'individualLearnings/viewAll': 'myLearningsIndividualLearning',
    'individualLearnings/requestLearning': 'myLearningsIndividualLearning',
    'user-details/:userId': {
      accessKey: '',
      extraPredicate: () => clientService.isOpenWorldProfileAccess()
    },
    'user-details/:userId/individualLearnings/viewAll': {
      accessKey: '',
      extraPredicate: () => clientService.isOpenWorldProfileAccess()
    },
    'userDetails/:empId': {
      accessKey: '',
      extraPredicate: () => clientService.isOpenWorldProfileAccess()
    },
    'marketIntelligence-company': 'marketIntelligence',
    'marketIntelligence-customer': 'marketIntelligence',
    'marketIntelligence-industry': 'marketIntelligence',
    'notifications': 'socialConnect',
    'internalJobPostingDetail/:jobId': 'internalJobPosting',
    'internalJobPostingApplication/:jobId': 'internalJobPosting',
    'badges': {
      accessKey: 'gamification',
      isAdminRoute: true,
      extraPredicate: () => badgesService.hasBadgesAccess()
    },
    'linkedin-parsing': 'linkedin',
    'karma-points/karma-point-detail/:tab': {
      accessKey: 'gamification',
      isAdminRoute: true,
      extraPredicate: () => karmaPointsService.hasKarmaPointsAccess
    },
    'integrations/app': 'integrations',
    'download': '',
  };

  return checkRouteAuthorization(route, state, router, clientService, routeCheckAccessMap, 'sms');
};
